import type { ReactNode } from 'react';

type Props = {
	title: string;
	titleClass?: string;
	description: string;
	descriptionClass?: string;
	icon?: ReactNode;
	iconClass?: string;
	className?: string;
};

export default function Block({
	title,
	titleClass,
	description,
	descriptionClass,
	icon,
	iconClass,
	className,
}: Props) {
	return (
		<div
			className={`flex flex-col gap-4 flex-1 p-4 rounded-xl border-2 max-lg:flex-auto ${className}`}
		>
			<div className="flex items-center justify-between gap-6">
				<h3 className={`text-4xl max-2xl:text-3xl font-bold ${titleClass}`}>{title}</h3>

				<div className={`relative w-[36px] h-[36px] ${iconClass}`}>{icon}</div>
			</div>

			<p
				className={`text-lg leading-6.5 max-xl:!text-[16px] max-xl:leading-6 font-medium ${descriptionClass}`}
			>
				{description}
			</p>
		</div>
	);
}
